/** Above this many unread conversations the tab shows "99+" rather than the exact count. */
export const UNREAD_DISPLAY_CAP = 99;

const BADGE_PREFIX = /^\(\d+\+?\)\s*/;

/**
 * Prefix the browser tab title with the number of conversations holding unread
 * messages. Counts conversations, not messages, so it matches the sidebar dot.
 */
export const formatTabTitle = (baseTitle: string, unreadConversations: number): string => {
  // A title read back from the document may already carry a badge from a previous update.
  const bareTitle = baseTitle.replace(BADGE_PREFIX, '');

  if (!Number.isFinite(unreadConversations) || unreadConversations <= 0) {
    return bareTitle;
  }

  const badge = unreadConversations > UNREAD_DISPLAY_CAP ? `${UNREAD_DISPLAY_CAP}+` : `${unreadConversations}`;

  return `(${badge}) ${bareTitle}`;
};
